import React from 'react';
import './Announcement.css';

const Announcement = () => {
  return (
    <section className="announcement">
      <div className="announcement-container">
        <div className="announcement-content">
          <span className="announcement-label">New</span>
          <p className="announcement-text">
            Discover how our latest technology solutions drive business innovation and growth
          </p>
          <a href="#learn-more" className="announcement-link">
            Learn more →
          </a>
        </div>
      </div>
    </section>
  );
};

export default Announcement;
